import endpoints from 'api/endpoints';
import { normalize } from 'normalizr';
import { post } from 'schemas';
import Immutable from 'immutable';

export default ({ requestBody }) => ({
  url: endpoints.getSinglePostUrl(requestBody.id),
  queryKey: `put${endpoints.getSinglePostUrl()}`,
  transform: response => normalize(response.data, post.schema).entities,
  body: requestBody,
  meta: {
    authToken: true,
  },
  force: true,
  options: {
    headers: {
      Accept: 'application/json',
    },
    method: 'PUT',
  },
  update: {
    post: (prevEntities = Immutable.Map(), nextEntities) => prevEntities.mergeDeep(nextEntities),
  },
});
